import {ieFix} from './utils/ie-fix';
import {iosVhFix} from './utils/ios-vh-fix';
import {vhFix} from './utils/vh-fix';

import {preloader} from './modules/preloader';

import {initModals} from './modules/init-modals';
import {animateBottle} from './modules/animate-bottle';
import {initBurger} from './modules/init-burger';
import {initAccordion} from './modules/init-accordion';
import {initPrizeSlider} from './modules/init-prizes-slider';
import {addParallax} from './modules/add-parallax';
import {changeColor} from './modules/change-color';
import {initWinnersSlider} from './modules/init-winners-slider';
import './modules/custom-select';
import './modules/tabs';
import {initPhoneMask} from './modules/init-phone-mask';
import {scrollToLink} from './modules/scroll-to-link';
import {observeFixed} from './modules/observe-fixed';


// Utils
// ---------------------------------

ieFix();
iosVhFix();
vhFix();


// Modules
// ---------------------------------
preloader();
initModals();
animateBottle();
initBurger();
initAccordion();
initPrizeSlider();
addParallax();
changeColor();
initPhoneMask();
scrollToLink();
observeFixed();
initWinnersSlider();
